// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"134":"lang-EN-json","443":"about","759":"lang-pt-json"}[chunkId] + "." + {"134":"3a692fb6","443":"afae51d2","759":"6f700c11"}[chunkId] + ".js";
};